module.exports = __webpack_public_path__ + "img/develop.7d639670.png";